import { render, staticRenderFns } from "./i-linvoice.vue?vue&type=template&id=f62999b2&"
import script from "./i-linvoice.vue?vue&type=script&lang=js&"
export * from "./i-linvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports